// This helper method helps to create an object that marks all rows pre-selected in a table
export const createAllSelectTableStateObject = (length?: number): Record<string, boolean> =>
  Object.fromEntries(Array.from({ length: length ?? 0 }, (_, i) => [i.toString(), true]));
